/* Tiny pub/sub for sync status.
   - markSynced(): record a successful API exchange.
   - markSyncing(): record an in-flight request.
   - subscribe(cb): receive state updates.
   - getState(): snapshot { lastSyncAt, syncing }
*/

const STORAGE_KEY = "orden_last_sync_at";

let state = {
  lastSyncAt: Number(localStorage.getItem(STORAGE_KEY)) || null,
  syncing: 0,
};

const listeners = new Set();

function emit() {
  listeners.forEach((cb) => {
    try { cb(state); } catch (_) { /* ignore */ }
  });
}

export function markSynced() {
  state = { ...state, lastSyncAt: Date.now(), syncing: Math.max(0, state.syncing - 1) };
  try { localStorage.setItem(STORAGE_KEY, String(state.lastSyncAt)); } catch (_) { /* quota */ }
  emit();
}

export function markSyncing() {
  state = { ...state, syncing: state.syncing + 1 };
  emit();
}

export function markSyncFailed() {
  state = { ...state, syncing: Math.max(0, state.syncing - 1) };
  emit();
}

export function subscribe(cb) {
  listeners.add(cb);
  cb(state);
  return () => listeners.delete(cb);
}

export function getState() {
  return state;
}
